import styled from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from '../../fields.constants';

export const Section = styled.section`
  margin-top: ${em(13)};
  padding-top: ${em(11)};
  border-top: ${em(1)} solid ${PALETTE.line};
`;

export const Head = styled.div`
  margin-bottom: ${em(7)};
  font-size: ${rem(14)};
  font-weight: 500;
  color: ${PALETTE.ink};

  span {
    margin-left: ${em(8)};
    font-size: ${rem(12.5)};
    font-weight: 400;
    color: ${PALETTE.muted};
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: ${em(118)} 1fr ${em(74)};
  gap: ${em(14)};
  align-items: center;
  margin-bottom: ${em(6)};
  padding: ${em(7)} ${em(10)};
  font-size: ${rem(12.5)};
  background: ${({ $late }) => ($late ? PALETTE.lateBg : PALETTE.panel)};
  border: ${em(1)} solid ${({ $late }) => ($late ? PALETTE.lateBorder : PALETTE.line)};
  border-radius: ${em(6)};
`;

export const Day = styled.span`
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: ${PALETTE.ink};
`;

export const Machine = styled.span`
  min-width: 0;
  color: ${PALETTE.muted};
`;

export const LateTag = styled.span`
  display: inline-block;
  margin-left: ${em(7)};
  padding: ${em(1)} ${em(7)};
  font-size: ${rem(11)};
  color: ${PALETTE.lateText};
  white-space: nowrap;
  background: ${PALETTE.lateTagBg};
  border: ${em(1)} solid ${PALETTE.lateBorder};
  border-radius: 999px;
`;

export const Percent = styled.span`
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: ${PALETTE.ink};
`;

export const Empty = styled.p`
  margin: 0;
  padding: ${em(10)} ${em(2)};
  font-size: ${rem(12.5)};
  line-height: 1.5;
  color: ${PALETTE.muted};

  b {
    font-weight: 500;
    color: ${PALETTE.ink};
  }
`;

export const RetryRow = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${em(12)};
    color: ${theme.colors.danger};
    font-size: ${rem(13)};
  `}
`;
